import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class VideoTransform extends EldmlTransform {
  apply() {
    this.selector.find("video").each((_, element) => {
      const video = $(element);
      const id = video.attr("video-id");
      if (!id) return;
      const platform = video.attr("platform") ?? "youtube";
      const height = video.attr("height") ?? "360px";
      const width = video.attr("width") ?? "640px";
      const source = video.attr("source") ?? "configuration";

      this.transformer.getVideoSrc(platform, source, id).then((src) => {
        switch (platform) {
          case "youtube":
            const result = $("<iframe></iframe>");
            result.addClass("eldml");
            result.attr("src", src);
            result.attr("width", width);
            result.attr("height", height);
            result.attr("allowfullscreen", "allowfullscreen");
            video.replaceWith(result);
            break;
          case "productive":
            video.attr("src", src);
            video.attr("controls", "controls");
            break;
        }
      });
    });
  }
}
